// Added by Sejune Oh on 2020-03-26
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC } from 'react'
import { createStyles, makeStyles } from '@material-ui/core'

// Helper
import Intl from '@/helper/Intl'

// UI
import { DialogWrapper, DialogWrapperProps, TitleTheme } from '../DialogWrapper'
import { Button } from '@/components/worklist/Button'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface
export interface DialogProps extends DialogWrapperProps {
  /** Messages */
  messages: string
  /** Error Message Block */
  ErrorMessage?: any
  /** confirm button text */
  btnTextConfirm?: string
  /** Confirm Evt Handler */
  onConfirmBtnClick?: (event: React.MouseEvent<HTMLSpanElement>) => void
  /** Has cancel button */
  hasCancelBtn?: boolean
  /** Cancel button text */
  btnTextCancel?: string
  /** Cancel Evt Handler */
  onCancelBtnClick?: (event: React.MouseEvent<HTMLSpanElement>) => void
  /** WC용 Styles  */
  classes?: any
  /** Title Theme */
  titleTheme?: TitleTheme
}

export interface ConfirmDialogProps {
  title: string
  message: string
  confirm?: (event: React.MouseEvent<HTMLSpanElement>) => void
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const ConfirmDialog: FC<DialogProps> = ({
  onConfirmBtnClick,
  onCancelBtnClick,
  onCloseBtnClick,
  messages,
  ErrorMessage,
  open,
  title: titleParam,
  btnTextConfirm: btnTextConfirmParam,
  btnTextCancel: btnTextCancelParam,
  hasCancelBtn = false,
  classes: webComponentClassses,
  titleTheme = 'confirm',
  ...props
}) => {
  // ! Style
  const classes = webComponentClassses
    ? webComponentClassses['confirmdialog']
    : makeStyles(() => createStyles({ ...customStyles }))()

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // ! I18n
  const title = titleParam || Intl.getIntlText({ id: 'htmljs_react.worklist.confirmdialog.title_default' })
  const btnTextConfirm =
    btnTextConfirmParam || Intl.getIntlText({ id: 'htmljs_react.worklist.confirmdialog.btn_default_confirm' })
  const btnTextCancel =
    btnTextCancelParam || Intl.getIntlText({ id: 'htmljs_react.worklist.confirmdialog.btn_default_cancel' })

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // ! Render
  return (
    <DialogWrapper
      classes={webComponentClassses}
      open={open}
      title={title}
      onCloseBtnClick={onCloseBtnClick}
      titleTheme={titleTheme}
      width={420}
      height={ErrorMessage ? 195 : 138}
      maxWidth={'md'}
    >
      <>
        <div className={classes.msgWrapper}>
          <p dangerouslySetInnerHTML={{ __html: messages }} />
          {ErrorMessage && ErrorMessage}
        </div>
        <div className={classes.ctrWrapper}>
          <Button
            customClassName={classes.buttonStyle}
            classes={webComponentClassses}
            disabled={false}
            onBtnClick={onConfirmBtnClick || onCloseBtnClick}
            autoFocus
          >
            {btnTextConfirm}
          </Button>
          {hasCancelBtn && (
            <Button
              customClassName={classes.buttonStyle}
              classes={webComponentClassses}
              disabled={false}
              onBtnClick={onCancelBtnClick || onCloseBtnClick}
            >
              {btnTextCancel}
            </Button>
          )}
        </div>
      </>
    </DialogWrapper>
  )
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ! Style
export const customStyles: Record<string, any> = {
  msgWrapper: {
    minWidth: '420px',
    padding: '14px 12px',
    minHeight: '57px',
    boxSizing: 'border-box',
    '& > p': {
      margin: 0,
      fontSize: '11px',
      color: '#fff',
      whiteSpace: 'pre-wrap'
    },
  },
  ctrWrapper: {
    padding: '18px 12px 10px 12px',
    display: 'flex',
    justifyContent: 'flex-end',
    '& > button': {
      marginLeft: '8px',
    },
  },
  buttonStyle: {
    minWidth: '120px',
    maxHeight: '24px',
  },
}

export default ConfirmDialog
